<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)" v-if="user && user.IDStB">
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">{{ title }}</div>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Sede del trámite</label>
            <v-select v-model="sede" :items="sedes" item-text="sede.Feriado" item-value="sede.IDF"
              label="Selecciona la sede" persistent-hint return-object single-line v-on:change="loadData">
            </v-select>
          </v-col>
        </v-row>
        <div v-if="pagos.length > 0"><br />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    #
                  </th>
                  <th class="text-left">
                    Concepto
                  </th>
                  <th class="text-left">
                    Monto
                  </th>
                  <th class="text-left">
                    Forma de pago
                  </th>
                  <th class="text-left">
                    Pagado Anterior
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pagoData,
                  pagoKey) in pagos" :key="pagoKey">
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.IDF }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.Concepto }}</td>
                  <td v-bind:style="colorText(pagoData)">${{ pagoData.Monto }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.forma_de_pago_data.Nombre }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.ultimo_pago == '' ? '-' : pagoData.ultimo_pago }}
                  </td>

                  <td>
                    <v-btn color="success" elevation="7" large v-on:click="examen = true"
                      @click="createCobranza(pagoData.IDF)">Pagar</v-btn>
                    <!-- <strong v-else>Pagado</strong> -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <!-- Selector de Sede -->
            <v-row class="mb-4">
              <v-col cols="12" md="6" lg="6" class="mx-auto">
                <div class="text-center mb-4">
                  <h2 class="text-subtitle-1 font-weight-bold primary-text">Sede del Trámite</h2>
                  <p class="text-caption grey--text text--darken-1">Selecciona la sede correspondiente para consultar tus pagos.</p>
                </div>
                <v-select
                  v-model="sede"
                  :items="sedes"
                  item-text="sede.Feriado"
                  item-value="sede.IDF"
                  label="Selecciona la sede"
                  return-object
                  outlined
                  rounded
                  color="primary"
                  class="premium-input"
                  v-on:change="loadData"
                  prepend-inner-icon="mdi-map-marker-outline"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Lista de Pagos -->
            <div v-if="pagos.length > 0">
              <h2 class="text-h6 font-weight-bold primary-text mb-4 mt-6">Pagos Pendientes y Realizados</h2>
              <v-row>
                <v-col cols="12" md="6" lg="6" v-for="(pagoData, pagoKey) in pagos" :key="pagoKey">
                  <v-card class="rounded-xl border-light hover-card h-100 d-flex flex-column bg-white" elevation="0">
                    <div class="pa-4 flex-grow-1">
                      
                      <div class="d-flex justify-space-between align-start mb-2">
                        <v-chip small class="font-weight-bold" color="grey lighten-4" text-color="grey darken-2">
                          #{{ pagoData.IDF }}
                        </v-chip>
                        
                        <!-- Estado visual (reemplazo de colorText) -->
                        <v-chip
                          small
                          :color="pagoData.pagado ? 'success lighten-5' : (pagoData.block ? 'grey lighten-4' : 'warning lighten-5')"
                          :text-color="pagoData.pagado ? 'success darken-1' : (pagoData.block ? 'grey darken-1' : 'warning darken-2')"
                          class="font-weight-bold"
                        >
                          <v-icon left small v-if="pagoData.pagado">mdi-check-circle</v-icon>
                          <v-icon left small v-else-if="pagoData.block">mdi-lock</v-icon>
                          <v-icon left small v-else>mdi-clock-outline</v-icon>
                          {{ pagoData.pagado ? 'Pagado' : (pagoData.block ? 'Bloqueado' : 'Pendiente') }}
                        </v-chip>
                      </div>

                      <h3 class="text-subtitle-1 font-weight-bold primary-text line-height-1 mt-3 mb-1">
                        {{ pagoData.Concepto }}
                      </h3>
                      
                      <div class="d-flex align-center mt-3 mb-2 gap-2">
                        <div class="text-h5 font-weight-black success--text text--darken-1 d-flex align-center">
                          <span class="text-caption mr-1 font-weight-bold">ARS</span>
                          ${{ pagoData.Monto }}
                        </div>
                      </div>

                      <v-divider class="my-3 border-light"></v-divider>

                      <div class="d-flex justify-space-between align-center text-caption">
                        <span class="grey--text font-weight-medium">Forma de pago:</span>
                        <span class="primary-text font-weight-bold">{{ pagoData.forma_de_pago_data.Nombre }}</span>
                      </div>
                      
                      <div class="d-flex justify-space-between align-center text-caption mt-1">
                        <span class="grey--text font-weight-medium">Pagado anterior:</span>
                        <span class="primary-text font-weight-bold">{{ pagoData.ultimo_pago == '' ? '-' : pagoData.ultimo_pago }}</span>
                      </div>

                    </div>

                    <!-- Botón de Pago -->
                    <div class="px-4 py-3 bg-light border-top mt-auto">
                      <v-btn
                        v-if="!pagoData.pagado && !pagoData.block"
                        color="primary"
                        block
                        rounded
                        elevation="2"
                        class="custom-btn-shadow font-weight-bold text-none"
                        @click="createCobranza(pagoData.IDF)"
                      >
                        <v-icon left>mdi-credit-card</v-icon> Pagar ahora
                      </v-btn>
                      
                      <v-btn
                        v-else-if="pagoData.pagado"
                        color="success"
                        block
                        rounded
                        outlined
                        disabled
                        class="font-weight-bold text-none"
                      >
                        <v-icon left>mdi-check-all</v-icon> Ya Abonado
                      </v-btn>

                      <v-btn
                        v-else
                        color="grey"
                        block
                        rounded
                        outlined
                        disabled
                        class="font-weight-bold text-none"
                      >
                        <v-icon left>mdi-lock-outline</v-icon> No disponible
                      </v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            
            <div v-else-if="sede.value && sedes.length > 0" class="text-center pa-10 bg-light-gradient rounded-xl mt-6">
              <v-icon size="64" color="grey lighten-2">mdi-inbox-outline</v-icon>
              <h3 class="text-h6 grey--text text--darken-1 mt-4">Sin pagos registrados</h3>
              <p class="text-body-2 grey--text">No encontramos trámites regulares asociados a esta sede.</p>
            </div>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "PaymentRegular",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: function () {
    return {
      title: "Efectuar pago",
      sede: { text: '', value: '' },
      sedes: [],
      pagos: [],
      total: 0,
      items: [],
      urlPay: '',
    }
  },

  methods: {
    async loadData() {
      if(!this.sede || !this.sede.sede || !this.sede.sede.IDF) return;
      this.$API
        .get({
          url: "alumno-pagos-regulares?alumno=" + this.user.IDStB + "&sede=" + this.sede.sede.IDF,
          data: {},
        })
        .then((res) => {
          this.pagos = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    colorText(pagoData) {
      let color = 'black';
      if (pagoData.block) {
        color = '#888';
      }
      if (pagoData.pagado) {
        color = 'green';
      }
      return { color: color }
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },

    changeTotal(pagoData, index) {
      pagoData.index = index;
      if (pagoData.check) {
        this.total += pagoData.precioAPagar;
      } else {
        this.total -= pagoData.precioAPagar;
      }
      let selecteds = this.pagos.items.filter(d => { return d.check; })
      this.items = selecteds.map((value) => { return { id: value.IDStB, monto: value.precioAPagar, index: value.index } })
      console.log(this.items)
    },

    async createCobranza(id) {
      let dataSend = {
        alumno: this.user.IDStB,
      };

      let url = "pago-concepto-regular/" + id;

      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          //Se crea la cobranza primero
          if (res.id) {
            this.pay(res)
          } else {
            alert('Pago en revisión')
          }

        });
    },

    async pay(res) {
      await this.$API
        .post({
          url: "alumno-pagos-regulares-pay/" + res.id,
          data: res
        }).then((resUrl) => {
          console.log(resUrl)
          location.href = resUrl
        });
    },
  },

  mounted() {
    this.$API
      .get({
        url: "alumno-sedes/" + this.user.IDStB,
        data: {},
      })
      .then((res) => {
        this.sedes = res;
      })
      .catch((err) => {
        console.log(err);
      });
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.pago-regular-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-top { border-top: 1px solid rgba(0, 0, 0, 0.05) !important; }

.hover-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15) !important;
}

.custom-btn-shadow {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
  transition: all 0.3s ease;
}
.custom-btn-shadow:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px -6px rgba(25, 118, 210, 0.5) !important;
}

.premium-input >>> .v-input__control > .v-input__slot {
  background-color: #ffffff !important;
  border-radius: 16px !important;
}
.premium-input >>> fieldset {
  border-color: rgba(0,0,0,0.08) !important;
}
.premium-input:hover >>> fieldset {
  border-color: rgba(25, 118, 210, 0.4) !important;
}

.gap-2 { gap: 8px; }

.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
